import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import "Common/global.scss";
import EmployeeForm from "./EmployeeForm";
import CompanyDoc from "./CompanyDoc";

export default function DocumentsStore() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* Company Doc */}
      <CompanyDoc />

      {/* Employee Form */}
      <EmployeeForm />
    </DashboardLayout>
  );
}
